/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicHolidayListModel } from '../../models/public-holiday-list-model';

export interface MasterDataPublicHolidaysGet$Params {
  languageRegion?: string;
}

export function masterDataPublicHolidaysGet(http: HttpClient, rootUrl: string, params?: MasterDataPublicHolidaysGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<PublicHolidayListModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataPublicHolidaysGet.PATH, 'get');
  if (params) {
    rb.query('languageRegion', params.languageRegion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<PublicHolidayListModel>>;
    })
  );
}

masterDataPublicHolidaysGet.PATH = '/MasterData/PublicHolidays';
